import { IConfigMarket } from '@Redux/interfaces'

const FAVORITE_TITLES_KEY = 'favoriteMarketTitles'

export const getFavoriteTitles = (): string[] => {
  try {
    const stored = localStorage.getItem(FAVORITE_TITLES_KEY)
    return stored ? JSON.parse(stored) : []
  } catch {
    return []
  }
}

export const addFavoriteTitle = (title: string): void => {
  const favorites = getFavoriteTitles()
  favorites.push(title)
  localStorage.setItem(FAVORITE_TITLES_KEY, JSON.stringify(favorites))
}

export const removeFavoriteTitle = (title: string) => {
  const favorites = getFavoriteTitles()
  const updated = favorites.filter((t) => t !== title)
  localStorage.setItem(FAVORITE_TITLES_KEY, JSON.stringify(updated))
}

export const removeAllFavoriteTitles = () => {
  localStorage.removeItem(FAVORITE_TITLES_KEY)
}

export const syncFavoritesFromLocalStorage = (markets: IConfigMarket[]): IConfigMarket[] => {
  const titles = getFavoriteTitles()
  return titles.map((title) => markets.find((m) => m.title === title)).filter((m): m is IConfigMarket => !!m)
}
